import { render, staticRenderFns } from "./priceListTemplateEditDialog.vue?vue&type=template&id=2899504e&"
import script from "./priceListTemplateEditDialog.vue?vue&type=script&lang=js&"
export * from "./priceListTemplateEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports